import { Select } from "antd";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  width: 100%;
`;

/**
 * Display component for boolean values
 * Handles: arrays, single value
 */
function UdfBooleanDisplay({ value }) {
  if (value === null || value === undefined) {
    return null;
  }

  // Handle array of values
  if (Array.isArray(value)) {
    return (
      <>
        {value.map((val, index) => (
          <span key={index}>
            <UdfBooleanDisplay value={val} />
            {index < value.length - 1 && ", "}
          </span>
        ))}
      </>
    );
  }

  if (typeof value === "string") {
    return <span>{value}</span>;
  }
  return <span>{value ? "True" : "False"}</span>;
}

/**
 * Boolean input component for UDF filters
 */
function UdfBooleanEdit({ addValue, currentValue, setCurrentValue }) {
  return (
    <StyledSelect
      popupMatchSelectWidth={false}
      placeholder="Select true/false to add"
      value={currentValue ?? null}
      onChange={(value) => {
        if (value === true || value === false) {
          addValue(value);
          setCurrentValue(null);
        }
      }}
      options={[
        { label: "True", value: true },
        { label: "False", value: false },
      ]}
    />
  );
}

/**
 * Factory function that returns both Edit and Display components
 */
function UdfBoolean() {
  return {
    Edit: UdfBooleanEdit,
    Display: UdfBooleanDisplay,
  };
}

export default UdfBoolean;
